import React from 'react';

import AppRoute from '../../shared/routes/AppRoute';
import Back from '../../layouts/Back';

import SubscriberOrdersList from '../../views/admin/subscribers/SubscriberOrdersList';

export default function AdminSubscribersRoutes() {
  return (
    <>
      <AppRoute
        exact
        path="/admin/subscribers/:subscriberType/management"
        layout={Back}
        component={SubscriberOrdersList}
      />
    </>
  );
}
